import {InfiniteScrollDirective} from './infinite-scroll.directive';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';


@NgModule({
    declarations: [
        InfiniteScrollDirective,
    ],
    exports: [
        InfiniteScrollDirective,
    ],
    imports: [
        CommonModule
    ]
})
export class CbInfiniteScrollModule {
}
